import { Grid, Stack, Text } from '@redbubble/design-system';
import { useViewportWidth } from '@redbubble/next/hooks';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { DeviceType } from '@redbubble/next/types';
import { AnalyticsItemsList } from '@redbubble/next-analytics/gtm';
import {
  RSPageType,
  RSProductClickedLocation,
} from '@redbubble/next-provider/rudderstack';
import { useEffect } from 'react';
import { DefaultInventoryItem } from 'types/shop-bff/types';
import { ProductCard } from '../../../../components/ProductCard';
import { getPreviewUrl } from '../../../../utils/common';
import { getPriceComponent } from '../../../../utils/getPriceComponent';
import { PreviewStyle } from '../../constants';

export const messages = defineMessages({
  alsoAvailableOnModalTitle: {
    defaultMessage: 'Available Products',
  },
});

export interface AlsoAvailableOnModalProps {
  items: DefaultInventoryItem[];
  matureContent?: boolean;
  artistName: string;
  onOpen?: () => void;
}

export const AlsoAvailableOnModal: React.FC<AlsoAvailableOnModalProps> = ({
  items,
  matureContent,
  artistName,
  onOpen,
}) => {
  const intl = useIntl();
  const { isOrAbove } = useViewportWidth();
  const isDesktop = isOrAbove(DeviceType.Desktop);

  useEffect(() => {
    if (onOpen) {
      onOpen();
    }
  }, [onOpen]);

  return (
    <Stack spacing="l">
      <Text type="display3" element="h2">
        {intl.formatMessage(messages.alsoAvailableOnModalTitle)}
      </Text>
      <Grid columns={isDesktop ? 4 : 2}>
        {items.map((item, index) => {
          if (!item) return null;

          const productUrl =
            item.productPageUrls?.url ||
            item.productPageUrls?.fallbackUrl ||
            '';
          const preview = getPreviewUrl(
            item,
            PreviewStyle.ALTERNATE_PRODUCT_CLOSE
          );

          const volumeDiscountThresholds =
            item.volumeDiscount?.thresholds || [];

          return (
            <ProductCard
              key={item.id}
              title={item.description}
              workTitle={item.description}
              artistName={artistName}
              link={productUrl}
              imageSrc={preview}
              matureContent={matureContent ?? false}
              analyticsIndex={index}
              analyticsComponentID={AnalyticsItemsList.AlsoAvailableOnModal}
              rsPageType={RSPageType.Product}
              rsLocation={RSProductClickedLocation.AlsoAvailableOnModal}
              stockStatus={item.stockStatus}
            >
              {getPriceComponent(volumeDiscountThresholds, item.price)}
            </ProductCard>
          );
        })}
      </Grid>
    </Stack>
  );
};
